//imports
import { all } from 'redux-saga/effects';

//Views
import alertTypeDetailsSagas from 'Modules/alertTypes/views/main/.components/alertTypeDetails/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        alertTypeDetailsSagas(),
    ]);
}